import { Component, OnInit } from '@angular/core';
import { OsnovZaGo } from './osnov-za-go';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osnov-za-go-modal-update',
  templateUrl: './osnov-za-go-modal-update.component.html'
})
export class OsnovZaGoModalUpdateComponent extends BaseModalUpdateComponent<OsnovZaGo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsnovZaGo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }
}
